import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from "dayjs";

export default function DateFieldComponent({
    label,
    variant = "standard",
    handleChange,
    disabled = false,
    defaultValue = undefined,
}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateField"]}>
                <DateField
                    required
                    label={label}
                    defaultValue={defaultValue ? dayjs(defaultValue, "DD/MM/YYYY") : undefined}
                    variant={variant}
                    disabled={disabled}
                    fullWidth
                    format="DD/MM/YYYY"
                    onChange={(newValue) => handleChange(newValue)}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
}
